module.exports = __webpack_public_path__ + "img/53c3cc5.jpg";